module.exports = __webpack_public_path__ + "media/教室1.25c4272a.mp4";